export const USER_ADMIN_ROLE = 'admin';

const USER_ADMIN_PROTECTED_EDGE_METHODS = [
    'ADD_COMPANY',
    'ADD_USER',
    'EDIT_COMPANY',
    'EDIT_USER',
    'GET_COMPANY',
    'GET_COMPANY_REGIONS_LISTS',
    'GET_ROLE_LIST',
    'GET_USER_ANALYTICS_BY_ID',
    'GET_USER_BY_ID',
    'LOGIN_AS_USER'
];

function collectionHasName(collection, expectedName) {
    return Array.isArray(collection) && collection.some((item) => item?.name === expectedName);
}

export function getUserAdminAccess(user) {
    if (user?.rolesLoading) {
        return {
            isAuthorized: false,
            isLoading: true,
            hasAdminRole: false,
            reason: 'loading'
        };
    }

    const rolesLoaded = Array.isArray(user?.roles);

    if (!rolesLoaded) {
        return {
            isAuthorized: false,
            isLoading: false,
            hasAdminRole: false,
            reason: 'missing-role'
        };
    }

    const hasAdminRole = collectionHasName(user.roles, USER_ADMIN_ROLE);

    return {
        isAuthorized: hasAdminRole,
        isLoading: false,
        hasAdminRole,
        reason: hasAdminRole ? 'authorized' : 'missing-role'
    };
}

export function canAccessUserAdmin(user) {
    return getUserAdminAccess(user).isAuthorized;
}

export function isUserAdminProtectedEdgeMethod(edgeMethod) {
    return USER_ADMIN_PROTECTED_EDGE_METHODS.includes(edgeMethod);
}

export function createUserAdminForbiddenResponse(access) {
    return {
        status: 403,
        data: {
            message: 'Unauthorized UserAdmin access',
            reason: access?.reason || 'unauthorized'
        }
    };
}
